import { useEffect, useState } from "react";
import { BadgePercent, CalendarCheck, Timer } from "lucide-react";

export function OfferCountdown({ offer, testid = "offer-countdown" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(t); }, []);
  if (!offer?.live || !offer.ends_at) return null;
  const left = new Date(`${offer.ends_at}T23:59:59Z`).getTime() - now;
  if (left <= 0 || left > 15 * 86400000) return null;
  const d = Math.floor(left / 86400000), h = Math.floor((left % 86400000) / 3600000), m = Math.floor((left % 3600000) / 60000);
  return <div className={`offer-countdown${d < 3 ? " urgent" : ""}`} data-testid={testid}><Timer size={16} /> Launch Offer ({offer.discount_pct}% OFF) खत्म होने में <b>{d > 0 ? `${d} दिन ${h} घंटे` : `${h} घंटे ${m} मिनट`}</b> · {offer.ends_at} तक</div>;
}

export const inr = (n = 0) => `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export function quoteOf(p, cycle) { return cycle === "yearly" ? p.yearly_quote : p.monthly_quote; }

export function PriceTag({ p, cycle, testid }) {
  if (p.key === "free" || !p.monthly_quote) return <div className="pt" data-testid={testid}><div className="pt-now"><b>₹0</b><small>Always Free</small></div></div>;
  const q = quoteOf(p, cycle); const per = cycle === "yearly" ? "/year" : "/month";
  return <div className="pt" data-testid={testid}>
    {q.discount_pct > 0 && <span className="pt-badge" data-testid={`${testid}-badge`}><BadgePercent size={13} /> Launch Offer · {q.discount_pct}% OFF</span>}
    <div className="pt-now"><b data-testid={`${testid}-payable`}>{inr(q.payable)}</b><small>{per}</small></div>
    {q.discount_pct > 0 && <div className="pt-std" data-testid={`${testid}-standard`}>Standard price <s>{inr(q.standard)}{per}</s> · you save {inr(q.discount_amount)}</div>}
    {cycle === "yearly" && <div className="pt-year" data-testid={`${testid}-yearly-note`}><CalendarCheck size={13} /> Pay for 10 months, get 12 months of service <s>{inr(q.list_value)}</s></div>}
    {cycle === "monthly" && q.discount_pct === 0 && <div className="pt-std">Standard price</div>}
  </div>;
}

export function CycleToggle({ cycle, setCycle, offer }) {
  const opts = [offer?.monthly_enabled !== false && "monthly", offer?.yearly_enabled !== false && "yearly"].filter(Boolean);
  if (opts.length < 2) return null;
  return <div className="cycle-toggle" data-testid="cycle-toggle">{opts.map(c => <button key={c} className={cycle === c ? "active" : ""} onClick={() => setCycle(c)} data-testid={`cycle-${c}`}>{c === "yearly" ? "Yearly · 12 months for price of 10" : "Monthly"}</button>)}</div>;
}

export function BillingTerms({ offer, testid = "billing-terms" }) {
  return <ul className="pt-terms" data-testid={testid}>
    <li>{offer?.trial_days || 14}-day free trial on every paid plan — no card needed.</li>
    {offer?.live && <li>Launch Offer: {offer.discount_pct}% off the standard monthly price{offer.ends_at ? ` till ${offer.ends_at}` : ""}. The discount may be reduced or ended later; the standard price stays the same.</li>}
    <li>Yearly plan: pay for 10 months, get 12 months of service.{offer?.stack_yearly ? " Launch Offer also applies to yearly." : " Launch Offer is not added on top of the yearly price."}</li>
    <li>Plans are prepaid — nothing is charged automatically. Each renewal is charged at the price shown on the day you renew.</li>
    <li>Free plan: up to 50 students, always free.</li>
  </ul>;
}
